import React, { Component } from 'react';
import * as Constants from './api/constants'

import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';

import AppNotificationList from './appNotifications.components/AppNotificationList'
import AppPriorityNotificationList from './appNotifications.components/AppPriorityNotificationList'
import AppNotificationEditor from './appNotifications.components/AppNotificationEditor';

import AddIcon from '@mui/icons-material/Add';

export default class AppNotifications extends Component {
  constructor(props) {
    super(props);

    this.state = {
      notifications: [],
      priorityNotifications: [],
      editorOpen: false,
      selected: null,
      loading: false
    };
  }

  componentDidMount() {
    this.load();
  }

  load = () => {
    this.setState({ loading: true });

    const requestOptions = {
      method: 'GET',
      credentials: "include"
    };

    const normalReq = fetch(Constants.baseURL + Constants.apiAppNotifications, requestOptions)
      .then(r => {
        if (!r.ok && r.status !== 404) throw new Error();
        return r.json();
      });

    const priorityReq = fetch(Constants.baseURL + Constants.apiAppNotifications + '?priority=true', requestOptions)
      .then(r => {
        if (!r.ok && r.status !== 404) throw new Error();
        return r.json();
      });

    Promise.all([normalReq, priorityReq])
      .then(([notifications, priorityNotifications]) => {
        this.setState({
          notifications,
          priorityNotifications,
          loading: false
        });
      })
      .catch(err => {
        console.log(err);
        this.setState({ loading: false });
        this.props.history.push('/');
      });
  };

  openAdd = (isPriority = false) => {
    this.setState({
      selected: { priority: isPriority },
      editorOpen: true
    });
  };

  openEdit = (item) => {
    this.setState({ selected: item, editorOpen: true });
  };

  closeEditor = () => {
    this.setState({ editorOpen: false, selected: null });
  };

  save = (payload) => {
    const isEdit = payload.id && payload.id > 0;

    const url = isEdit
      ? Constants.apiUpdateAppNotification
      : Constants.apiAddAppNotification;

    fetch(Constants.baseURL + url, {
      method: 'POST',
      credentials: 'include',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    })
      .then(r => {
        if (!r.ok) throw new Error();
        this.closeEditor();
        this.load();
      })
      .catch(err => console.log(err));
  };

  render() {
    return (
      <Container maxWidth="900px" sx={{ mt: 4, mb: 4 }}>
        <Grid item xs={12} md={12} lg={12}>
          <Paper sx={{
            p: 2, minHeight: 600, bgcolor: 'rgba(255,255,255,0.04)',
            border: '1px solid rgba(255,255,255,0.08)'
          }}>

            <div style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              marginBottom: '10px'
            }}>
              <Typography variant="h6">
                Notifications
              </Typography>

              <Button
                variant="contained"
                startIcon={<AddIcon />}
                onClick={() => this.openAdd(false)}
              >
                Add Notification
              </Button>
            </div>

            <AppNotificationList
              data={this.state.notifications}
              onEdit={this.openEdit}
              loading={this.state.loading}
              refreshData={this.load}
            />
          </Paper>
        </Grid>

        <Grid item xs={12} md={12} lg={12} sx={{ mt: 5 }}>
          <Paper sx={{
            p: 2, minHeight: 600, bgcolor: 'rgba(255,255,255,0.04)',
            border: '1px solid rgba(255,255,255,0.08)'
          }}>

            <div style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              marginBottom: '10px'
            }}>
              <Typography variant="h6">
                Urgent Notifications
              </Typography>

              <Button
                variant="contained"
                startIcon={<AddIcon />}
                onClick={() => this.openAdd(true)}
              >
                Add Notification
              </Button>
            </div>

            <AppPriorityNotificationList
              data={this.state.priorityNotifications}
              onEdit={this.openEdit}
              loading={this.state.loading}
              refreshData={this.load}
            />
          </Paper>
        </Grid>

        <AppNotificationEditor
          open={this.state.editorOpen}
          data={this.state.selected}
          onClose={this.closeEditor}
          onSave={this.save}
        />
      </Container>
    );
  }
}